/**
 * Cart drawer KVKK consent - checkbox işaretlenmeden checkout engellenir, alert gösterilir.
 * Re-inits on cart:update (after morph) since inline scripts in morphed content don't run.
 */
import { ThemeEvents } from '@theme/events';

function getAlertMsg() {
  const wrap = document.querySelector('.cart-drawer-kvkk-wrapper');
  return wrap?.getAttribute('data-kvkk-error') || 'Please read and accept the disclosure text.';
}

const CHECKOUT_SELECTORS = [
  '[name="checkout"]',
  '[name="goto_checkout"]',
  '[name="checkout_continue"]',
  '#checkout',
  'a[href*="/checkout"]',
  'shopify-accelerated-checkout-cart',
  'shopify-accelerated-checkout',
];

function isCheckoutButton(el) {
  if (!el || !el.closest) return false;
  const target = el.closest('button, a, [role="button"]') || el;
  return CHECKOUT_SELECTORS.some((sel) => target.matches?.(sel) || target.closest?.(sel));
}

function getCheckboxForContext(clickTarget) {
  const summary = clickTarget.closest('.cart-drawer__summary, .cart-page__summary');
  const wrap = summary?.querySelector('.cart-drawer-kvkk-wrapper');
  return wrap?.querySelector('.cart-drawer-kvkk-checkbox');
}

function handleGlobalClick(e) {
  if (!isCheckoutButton(e.target)) return;
  const checkbox = getCheckboxForContext(e.target);
  if (!checkbox || checkbox.checked) return;
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  checkbox.focus();
  alert(getAlertMsg());
  const wrap = checkbox.closest('.cart-drawer-kvkk-wrapper');
  if (wrap) {
    wrap.classList.add('cart-drawer-kvkk-shake');
    setTimeout(() => wrap.classList.remove('cart-drawer-kvkk-shake'), 600);
  }
  return false;
}

function init() {
  const wrap = document.querySelector('.cart-drawer-kvkk-wrapper');
  if (!wrap) return;

  const checkbox = wrap.querySelector('.cart-drawer-kvkk-checkbox');
  const errorEl = wrap.querySelector('.cart-drawer-kvkk-error');
  const checkoutBtn = document.getElementById('checkout');
  const form = document.getElementById('cart-form');

  if (!checkbox) return;

  function applyState() {
    if (checkoutBtn) checkoutBtn.disabled = !checkbox.checked;
  }

  function showError() {
    if (errorEl) {
      errorEl.textContent = getAlertMsg();
      clearTimeout(wrap._kvkkTimer);
      wrap._kvkkTimer = setTimeout(() => {
        errorEl.textContent = '';
      }, 4000);
    }
    wrap.classList.add('cart-drawer-kvkk-shake');
    setTimeout(() => wrap.classList.remove('cart-drawer-kvkk-shake'), 600);
  }

  function onCheckboxChange() {
    if (errorEl) errorEl.textContent = '';
    wrap.classList.remove('cart-drawer-kvkk-shake');
    applyState();
  }

  function onFormSubmit(e) {
    if (!checkbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      checkbox.focus();
      alert(getAlertMsg());
      showError();
      return false;
    }
  }

  checkbox.removeEventListener('change', onCheckboxChange);
  checkbox.addEventListener('change', onCheckboxChange);

  if (form) {
    form.removeEventListener('submit', onFormSubmit, true);
    form.addEventListener('submit', onFormSubmit, true);
  }

  document.removeEventListener('click', handleGlobalClick, true);
  document.addEventListener('click', handleGlobalClick, true);

  applyState();
}

function initWithDelay() {
  setTimeout(init, 50);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener(ThemeEvents.cartUpdate, initWithDelay);
